import React, {forwardRef, FunctionComponent} from 'react'
import {useForm} from "react-hook-form";
import {doLoginAttempt} from "../store/system-actions";
import {useDispatch, useSelector} from "react-redux";
import {Button, Classes, Dialog, FormGroup, InputGroup} from "@blueprintjs/core";
import {RootState} from "../reducers/root-reducer";
import {HIDE_LOGIN_MODAL} from "../store/modal-action-types";

type LoginFormData = {
    email: string
    password: string
}

const LoginDialog: FunctionComponent = (props, ref) => {

    const dispatch = useDispatch()

    const isOpen = useSelector<RootState, boolean>(s => s.modalState.loginIsOpen)

    const {handleSubmit, register, errors} = useForm<LoginFormData>({mode: "onSubmit", reValidateMode: "onChange"})

    function closeDialog() {
        dispatch({type: HIDE_LOGIN_MODAL})
    }

    function doLogin(values: LoginFormData) {
        dispatch(doLoginAttempt(values.email, values.password))
    }

    return (
        <Dialog isOpen={isOpen} canOutsideClickClose={true} onClose={closeDialog} isCloseButtonShown={true}
                title={"Sign In into GiveMeThatPicture"}>
            <div className={Classes.DIALOG_BODY}>
                <FormGroup>
                    <InputGroup inputRef={register({
                        required: "Required",
                        pattern: {
                            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                            message: "Invalid email address"
                        }
                    })} placeholder="Email" name="email" onSubmit={handleSubmit(doLogin)}
                                type={"email"}/>
                    {errors.email && <span className={"bp3-intent-danger"}>
                            {errors.email.message}
                        </span>}
                </FormGroup>

                <FormGroup>
                    <InputGroup inputRef={register({required: "Required"})} placeholder="Password" name="password"
                                type="password" onSubmit={handleSubmit(doLogin)}/>
                    {errors.password && <span className={"bp3-intent-danger"}>
                            {errors.password.message}
                        </span>}
                </FormGroup>
            </div>
            <div className={Classes.DIALOG_FOOTER}>
                <Button onClick={handleSubmit(doLogin)}>Login</Button>
            </div>
        </Dialog>
    )

}

export default forwardRef(LoginDialog)